import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ChildProfileDetail } from '@isophi/mng-api';

@Component({
  selector: 'app-child-info-diagnostic-tab',
  templateUrl: './child-info-diagnostic-tab.component.html',
  styleUrls: ['./child-info-diagnostic-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChildInfoDiagnosticTabComponent {
  @Input()
  child: ChildProfileDetail;
}
